






import { Component, Vue } from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import XTabs from "@/components/SimpleTabs.vue";
import DocumentsTabContent from "@/components/for-documents-view/DocumentsTabContent.vue";
import ContractDocumentsTabContent from "@/components/for-documents-view/ContractDocumentsTabContent.vue";
import ContractDocumentsEdoTabContent from "@/components/for-documents-view/ContractDocumentsEdoTabContent.vue";

@Component({
  components: {
    Page,
    XTabs,
    DocumentsTabContent,
    ContractDocumentsTabContent,
    ContractDocumentsEdoTabContent,
  },
})
class Documents extends Vue {
  titles = ["Документы", "Документы договора", "Документы ЭДО"];

  components = [DocumentsTabContent, ContractDocumentsTabContent, ContractDocumentsEdoTabContent];

  mounted() {
  }
}

export default Documents;
